import { ReactNode } from "react";
import { Container, Left, Center, Right, Smart, Picks } from "./styles";

function StickyHeader({
  leftNode,
  rightNode,
}: {
  leftNode?: ReactNode;
  rightNode?: ReactNode;
}): JSX.Element {
  return (
    <Container>
      <Left>{leftNode}</Left>
      <Center>
        <Smart>SMART</Smart><Picks>PICKS</Picks>
      </Center>
      <Right>{rightNode}</Right>
    </Container>
  );
}

export default StickyHeader;
